function pushToDataLayer(item: any) {
  (<any>window).dataLayer.push(item);
}

export default pushToDataLayer;
